import styled from 'styled-components';
import { Card } from '@veneer/core';
import primitives from '@veneer/primitives';
import { mixins } from '@jarvis/react-portal-addons';

export const CardBody = styled(Card)`
  && {
    grid-column: span 4;
    border: 1px solid ${({ theme }) => theme.color.stroke.decorative.default};
    min-height: 204px;
    grid-column: span 12;

    ${mixins.md(`
      grid-column: span 6;
      min-height: 244px;
    `)}

    ${mixins.xl(`
      grid-column: span 4;
    `)}

    @media (min-width: 1920px) {
      min-height: 220px;
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  height: 100%;

  ${mixins.xs(`
    width: 100%;
  `)}
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px 16px 0 0;
  background: ${({ theme }) => theme.color.background.default};
  padding: 8px 12px;

  > svg {
    margin-right: 8px;
    width: 20px;
    min-width: 20px;
  }
`;

export const HeaderText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${primitives.color.gray9};
  margin: 0;
  text-align: center;
`;

export const ContentContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  position: relative;
`;

export const ImageContainer = styled.div`
  width: 40px;
  height: 40px;
  position: absolute;
  top: 16px;
  right: 28px;
  background-color: ${({ theme }) => theme.color.primary.background.default};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    color: ${primitives.color.electricBlue6};
    width: 28px;
    height: 28px;
  }
`;

export const Title = styled.h1`
  margin: 0 68px 0 12px;
`;

export const Description = styled.p`
  margin: 12px 68px auto 12px;
`;

export const Footer = styled.div`
  margin: 16px 0 0 0;
`;
